import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { InputBaseProps } from "./InputBaseProps";

export default function Input({
  name,
  customClass,
  id,
  type,
  placeholder="",
  inputValue,
  autoComplete,
  label,
  isError,
  isValid,
  errorMessage,
  onChange,
  onBlur,
  onKeyDown,
  ...args
}: InputBaseProps) {
  const autoCompleteType = autoComplete ? "on" : "off";
  const [, setValue] = useState(inputValue ?? "");

  return (
    <>
      <div className="floating-input-container">
        <input
          placeholder={placeholder === "" ? " " : placeholder}
          name={name}
          className={`form-control ${customClass} ${isValid?"custom-date":""}`}
          type={type}
          autoComplete={autoCompleteType}
          onChange={(e) => {
            onChange(e);
            setValue(e.target.value);
          }}
          onBlur={(e) => {
            onBlur(e);
            setValue(e.target.value);
          }}
          value={inputValue}
          onKeyDown={onKeyDown}
          aria-autocomplete="list"
        />
        <label className="float-label" htmlFor="">
          {label}
        </label>
        {isValid && (
          <span className="tick-validate right-position">
            <SVG
              className="tick-icon"
              src="Assets/Images/Icons/tick-icon.svg"
              width="16"
              height="16"
            />
          </span>
        )}
        {isError ? <label className="text-error">{errorMessage}</label> : ""}
      </div>
    </>
  );
}
